
import { INSTAGRAM_APP_ID, LINKEDIN_APP_ID } from "src/constants/socialPlatformAppId";
import { InstagramResponseURL, InstagramScopes, LinkedInResponseURL, LinkedInScopes } from "./Enums";
import { ENVIRONMENT } from "src/scenes/App";

/**
 * Get the URL for the Business Portal, assuming it's using HTTPS (required by our Meta app)
 *
 * Local development of the Instagram integration this requires using HTTPS. This is because our Meta app "Me Business
 * Portal" is now in Live mode, so HTTP redirect URLs are not allowed.
 * See [README.md] for instructions on using HTTPS on localhost.
 *
 * @returns {string}
 */
const businessPortalUrl = () => {
    switch (ENVIRONMENT.get()) {
        case ENVIRONMENT.PRODUCTION:
            return "https://business.memotivationapp.com/";
        case ENVIRONMENT.STAGING:
            return "https://staging.memotivationapp.com/";
        case ENVIRONMENT.PROTOTYPE:
            return "https://prototype.memotivationapp.com/";
        default:
            return "https://localhost:3000/";
    }
};

export const getInstagramOauthUrl = () => "https://www.instagram.com/oauth/authorize"
    + "?enable_fb_login=0"
    + "&force_authentication=1"
    + "&client_id=" + INSTAGRAM_APP_ID
    + "&redirect_uri=" + businessPortalUrl() + InstagramResponseURL
    + "&response_type=code"
    + "&scope=" + InstagramScopes;

export const getLinkedInOauthUrl = () => "https://www.linkedin.com/oauth/v2/authorization"
    + "?response_type=code"
    + "&client_id=" + LINKEDIN_APP_ID
    + "&scope=" + LinkedInScopes
    + "&redirect_uri=" + businessPortalUrl() + LinkedInResponseURL;
